import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import Modal from '../components/Modal';
import { api } from '../utils/api';
import auth from '../utils/auth';
import useQueryString from '../utils/useQueryString';

// 토스 카드 등록창에서 돌아오는 페이지 → 빌링키 발급 + 첫 달 결제
const BillingSuccess = () => {
  const history = useHistory();
  const query = useQueryString();
  const [status, setStatus] = useState<'loading' | 'done' | 'error'>(query.done ? 'done' : 'loading');
  const [message, setMessage] = useState('');
  const [firstChargeAt, setFirstChargeAt] = useState<string>(query.first || '');

  useEffect(() => {
    if (query.done) return;
    if (!query.authKey || !query.customerKey) {
      setMessage('올바르지 않은 접근입니다.');
      setStatus('error');
      return;
    }
    const start = async () => {
      try {
        const { data } = await api.post('/billing/start', {
          authKey: query.authKey,
          customerKey: query.customerKey,
        });
        if (data.success) {
          auth.setPayStatus(1);
          const first = data.data.migrated ? data.data.first_charge_at : '';
          setFirstChargeAt(first);
          // 새로고침해도 다시 결제 요청하지 않도록 주소에서 authKey 를 지운다
          history.replace(`/billing/success?done=1${first ? `&first=${first}` : ''}`);
          setStatus('done');
        } else {
          setMessage(data.alert || '결제에 실패했습니다.');
          setStatus('error');
        }
      } catch (e) {
        setMessage('일시적인 오류로 실패하였습니다. 잠시 후 다시 시도해주세요.');
        setStatus('error');
      }
    };
    start();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (status === 'loading') {
    return <Modal open={true} onClose={() => {}} title="결제 진행 중" content={<>잠시만 기다려주세요...</>} />;
  }

  if (status === 'done' && firstChargeAt) {
    return (
      <Modal
        open={true}
        onClose={() => history.push('/')}
        firstButtonLabel="확인"
        onClickFirstButton={() => {
          history.push('/');
          window.location.reload();
        }}
        title="결제 방식 변경 완료"
        content={
          <>
            카드 등록이 완료되었습니다. <br />
            {firstChargeAt}부터 등록하신 카드로 매월 자동 결제되며, 그 전에는 결제되지 않습니다. <br />
            지금처럼 계속 악보를 열람하실 수 있습니다.
          </>
        }
      />
    );
  }

  if (status === 'done') {
    return (
      <Modal
        open={true}
        onClose={() => history.push('/')}
        firstButtonLabel="확인"
        onClickFirstButton={() => {
          history.push('/');
          window.location.reload();
        }}
        title="구독 완료"
        content={
          <>
            구독이 시작되었습니다. <br />
            지금부터 무제한 악보 열람이 가능합니다. <br />
            등록하신 카드로 매월 자동 결제되며, 언제든 메뉴의 &apos;구독 해지&apos;에서 해지할 수 있습니다. <br />
            즐거운 연주 되세요.
          </>
        }
      />
    );
  }

  return (
    <Modal
      open={true}
      onClose={() => history.push('/')}
      firstButtonLabel="확인"
      onClickFirstButton={() => history.push('/')}
      title="구독 실패"
      content={<>{message}</>}
    />
  );
};

export default BillingSuccess;
